import i18n from 'i18next';
import {
    FieldDefinitionFieldTypeNumeric,
    FilterCategory,
} from '@components-clean/core/filter-ui/action-bar/shared/interfaces';

export const filterColumns = (
    HasCMControlsPermission: boolean,
    includeLtd?: boolean,
    hasCommentsPermission?: boolean,
) => {
    const bumpIndexes = HasCMControlsPermission ? 2 : 0;
    return [
        {
            id: 0,
            items: [
                {
                    id: 1,
                    index: 0,
                    label: i18n.t('ram:riskLog.grids.risks.columns.statement'),
                    fieldKey: 'statement',
                    isDefault: true,
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                },
                {
                    id: 2,
                    index: 1,
                    fieldKey: 'score',
                    valueKey: 'colour',
                    label: i18n.t('ram:riskLog.grids.risks.filters.riskScoreCurrentColour'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    valueOrder: [
                        i18n.t('ram:riskLog.riskRating.RED'),
                        i18n.t('ram:riskLog.riskRating.AMBER'),
                        i18n.t('ram:riskLog.riskRating.GREEN'),
                    ],
                },
                {
                    id: 6,
                    index: 2,
                    fieldKey: 'score',
                    valueKey: 'score',
                    label: i18n.t('ram:riskLog.grids.risks.filters.riskScoreCurrentValue'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                },
                {
                    id: 7,
                    index: 3,
                    fieldKey: 'score',
                    valueKey: 'prevColour',
                    label: i18n.t('ram:riskLog.grids.risks.filters.riskScorePreviousColour'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    valueOrder: [
                        i18n.t('ram:riskLog.riskRating.RED'),
                        i18n.t('ram:riskLog.riskRating.AMBER'),
                        i18n.t('ram:riskLog.riskRating.GREEN'),
                    ],
                },
                {
                    id: 38,
                    index: 4,
                    fieldKey: 'score',
                    valueKey: 'prevScore',
                    label: i18n.t('ram:riskLog.grids.risks.filters.riskScorePreviousValue'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                },
                {
                    id: 39,
                    index: 5,
                    fieldKey: 'score',
                    valueKey: 'movement',
                    label: i18n.t('ram:riskLog.grids.risks.filters.riskScoreDirection'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    excludeBlank: true,
                    valueOrder: [
                        i18n.t('ram:riskLog.grids.risks.movement.RISING'),
                        i18n.t('ram:riskLog.grids.risks.movement.FALLING'),
                        i18n.t('ram:riskLog.grids.risks.movement.STABLE'),
                    ],
                },
                {
                    id: 3,
                    fieldKey: 'likelihood',
                    label: i18n.t('ram:riskLog.grids.risks.columns.likelihood'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 6,
                },
                {
                    id: 4,
                    fieldKey: 'impact',
                    label: i18n.t('ram:riskLog.grids.risks.columns.impact'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 7,
                },
                {
                    id: 5,
                    fieldKey: 'detectability',
                    label: i18n.t('ram:riskLog.grids.risks.columns.detectability'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 8,
                },
                ...(includeLtd
                    ? [
                          {
                              id: 37,
                              fieldKey: 'ltd',
                              label: i18n.t('ram:riskLog.grids.risks.columns.ltd'),
                              dataType: FieldDefinitionFieldTypeNumeric.Int,
                              isDefault: false,
                              index: 8,
                          },
                      ]
                    : []),
                {
                    id: 8,
                    fieldKey: 'rationale',
                    label: i18n.t('ram:riskLog.grids.risks.columns.rationale'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 9,
                },
                ...(hasCommentsPermission
                    ? [
                          {
                              id: 'numOpenComments',
                              fieldKey: 'commentCounts',
                              valueKey: 'open',
                              label: i18n.t('ram:riskLog.grids.risks.columns.numOpenComments'),
                              dataType: FieldDefinitionFieldTypeNumeric.Int,
                              isDefault: false,
                              index: 10,
                          },
                      ]
                    : []),
                {
                    id: 10,
                    fieldKey: 'dateIdentified',
                    label: i18n.t('ram:riskLog.grids.risks.columns.dateIdentified'),
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    ignoreTime: true,
                    isDefault: false,
                    index: 11,
                },
                {
                    id: 11,
                    fieldKey: 'category',
                    valueKey: 'name',
                    label: i18n.t('ram:riskLog.grids.risks.columns.category'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 12,
                },
                {
                    id: 12,
                    fieldKey: 'status',
                    label: i18n.t('ram:riskLog.grids.risks.columns.riskStatus'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 13,
                },
                {
                    id: 36,
                    fieldKey: 'closedDate',
                    label: i18n.t('ram:riskLog.grids.risks.columns.closedDate'),
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    ignoreTime: true,
                    isDefault: false,
                    index: 14,
                },
                {
                    id: 13,
                    fieldKey: 'reviewRequired',
                    label: i18n.t('ram:riskLog.grids.risks.columns.reviewRequired'),
                    dataType: FieldDefinitionFieldTypeNumeric.Bool,
                    isDefault: false,
                    index: 15,
                },
                {
                    id: 14,
                    fieldKey: 'reviewFrequency',
                    label: i18n.t('ram:riskLog.grids.risks.columns.reviewFrequency'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 16,
                },
                {
                    id: 15,
                    fieldKey: 'dateLastReviewed',
                    label: i18n.t('ram:riskLog.grids.risks.columns.lastReviewed'),
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    ignoreTime: true,
                    isDefault: false,
                    index: 17,
                },
                {
                    id: 16,
                    fieldKey: 'nextReviewDate',
                    label: i18n.t('ram:riskLog.grids.risks.columns.nextReview'),
                    ignoreTime: true,
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    isDefault: false,
                    index: 18,
                },
                {
                    id: 17,
                    fieldKey: 'reviewStatus',
                    label: i18n.t('ram:riskLog.grids.risks.columns.reviewStatus'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 19,
                },
                ...(HasCMControlsPermission
                    ? [
                          {
                              id: 34,
                              fieldKey: 'numLinkedCMControls',
                              label: i18n.t('ram:riskLog.grids.risks.columns.numLinkedCMControls'),
                              dataType: FieldDefinitionFieldTypeNumeric.Int,
                              isDefault: false,
                              index: 20,
                          },
                          {
                              id: 35,
                              fieldKey: 'oot',
                              label: i18n.t('ram:riskLog.grids.risks.columns.oot'),
                              dataType: FieldDefinitionFieldTypeNumeric.Text,
                              isDefault: false,
                              index: 21,
                          },
                      ]
                    : []),
                // Hidden but not removed as will be added back in at some point.
                // {
                //     id: 18,
                //     fieldKey: 'qualityIssue',
                //     valueKey: 'name',
                //     label: i18n.t('ram:riskLog.grids.risks.columns.qualityIssue'),
                //     dataType: FieldDefinitionFieldTypeNumeric.Text,
                //     isDefault: false,
                //     index: 20 + bumpIndexes,
                // },
                // {
                //     id: 19,
                //     fieldKey: 'qualityIssueReference',
                //     label: i18n.t('ram:riskLog.grids.risks.columns.qualityIssueReference'),
                //     dataType: FieldDefinitionFieldTypeNumeric.Text,
                //     isDefault: false,
                //     index: 21 + bumpIndexes,
                // },
                {
                    id: 18,
                    fieldKey: 'convertedOwner',
                    valueKey: 'name',
                    label: i18n.t('ram:riskLog.grids.risks.columns.owner'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 20 + bumpIndexes,
                },
                {
                    id: 19,
                    fieldKey: 'responsibleFunction',
                    valueKey: 'name',
                    label: i18n.t('ram:riskLog.grids.risks.columns.responsibleFunction'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 21 + bumpIndexes,
                },
                {
                    id: 20,
                    fieldKey: 'controlStrategy',
                    valueKey: 'name',
                    label: i18n.t('ram:riskLog.grids.risks.columns.controlStrategy'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 22 + bumpIndexes,
                },
                {
                    id: 21,
                    fieldKey: 'internalOnly',
                    label: i18n.t('ram:riskLog.grids.risks.columns.internal'),
                    dataType: FieldDefinitionFieldTypeNumeric.Bool,
                    isDefault: false,
                    index: 23 + bumpIndexes,
                },
                {
                    id: 22,
                    fieldKey: 'vendorList',
                    label: i18n.t('ram:riskLog.grids.risks.columns.vendors'),
                    dataType: FieldDefinitionFieldTypeNumeric.CSV,
                    isDefault: false,
                    index: 24 + bumpIndexes,
                },
                {
                    id: 23,
                    fieldKey: 'countryList',
                    label: i18n.t('ram:riskLog.grids.risks.columns.countries'),
                    dataType: FieldDefinitionFieldTypeNumeric.CSV,
                    isDefault: false,
                    index: 25 + bumpIndexes,
                },
                {
                    id: 24,
                    fieldKey: 'activeControlCount',
                    label: i18n.t('ram:riskLog.grids.risks.columns.numActiveControls'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 26 + bumpIndexes,
                },
                {
                    id: 25,
                    fieldKey: 'numActiveCtQs',
                    label: i18n.t('ram:riskLog.grids.risks.columns.numActiveCtQs'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 27 + bumpIndexes,
                },
                {
                    id: 26,
                    fieldKey: 'numOpenObservations',
                    label: i18n.t('ram:riskLog.grids.risks.columns.numOpenObservations'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 28 + bumpIndexes,
                },
                {
                    id: 27,
                    fieldKey: 'numOpenActions',
                    label: i18n.t('ram:riskLog.grids.risks.columns.numOpenActions'),
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 29 + bumpIndexes,
                },
                {
                    id: 9,
                    fieldKey: 'recordId',
                    label: 'ID',
                    dataType: FieldDefinitionFieldTypeNumeric.Int,
                    isDefault: false,
                    index: 30 + bumpIndexes,
                },
                {
                    id: 28,
                    fieldKey: 'createdBy',
                    label: i18n.t('ram:riskLog.grids.risks.columns.createdBy'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    index: 31 + bumpIndexes,
                },
                {
                    id: 29,
                    fieldKey: 'created',
                    label: i18n.t('ram:riskLog.grids.risks.columns.created'),
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    isDefault: false,
                    ignoreTime: true,
                    index: 32 + bumpIndexes,
                },
                {
                    id: 30,
                    fieldKey: 'updatedBy',
                    label: i18n.t('ram:riskLog.grids.risks.columns.updatedBy'),
                    isDefault: false,
                    index: 33 + bumpIndexes,
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                },
                {
                    id: 31,
                    fieldKey: 'updated',
                    label: i18n.t('ram:riskLog.grids.risks.columns.updated'),
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    isDefault: false,
                    ignoreTime: true,
                    index: 34 + bumpIndexes,
                },
            ],
        },
    ] as FilterCategory[];
};
